import useApi, { ApiOptions } from '../base/useApi';
import JobDTO from '@src/adapters/dto/job/JobDTO';

interface Params {
  dateFrom: Date;
  dateTo: Date;
}

interface Result {
  jobs: JobDTO[];
}

const options: ApiOptions = {
  method: 'get',
  urlPath: '/job/find_for_booking',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useFindBookingJobsLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useFindBookingJobsLazy;
